import { LevelDef } from '../level';

/**
 * Enduro loop through pine forest, ~3.1 km: a wiggled ellipse about 1.1 x 0.8 km. The two hills sit on the
 * line, so the route climbs and descends each of them.
 */
export const ENDURO: LevelDef = {
  id: 'enduro',
  name: 'Enduro forest',
  seed: 303,
  ground: { amplitude: 1.5, scale: 70, surface: 'grass' },
  hills: [
    { x: 0, z: 393, radius: 35, height: 14 },
    { x: 0, z: -367, radius: 50, height: 9 },
  ],
  pads: [],
  track: {
    points: [
      [542, 0], [554, 43], [531, 82], [500, 119], [485, 158], [474, 200], [442, 235], [382, 251], [318, 258], [273, 275],
      [246, 311], [215, 352], [167, 375], [110, 378], [54, 379], [0, 393], [-59, 408], [-117, 401], [-163, 366], [-197, 323],
      [-235, 297], [-288, 290], [-346, 281], [-388, 256], [-413, 219], [-441, 186], [-489, 159], [-540, 128], [-560, 87], [-537, 41],
      [-498, 0], [-480, -37], [-486, -76], [-489, -116], [-465, -151], [-426, -180], [-400, -212], [-391, -257], [-378, -307], [-338, -340],
      [-274, -347], [-208, -342], [-154, -347], [-106, -365], [-54, -377], [0, -367], [50, -348], [100, -342], [159, -357], [226, -371],
      [285, -361], [323, -325], [350, -284], [384, -253], [428, -227], [459, -194], [461, -150], [449, -107], [458, -71], [498, -38],
    ],
    width: 4,
    blend: 5,
    surface: 'clay',
    spans: [
      { from: 1850, to: 1930, surface: 'sand' },
      { from: 2200, to: 2260, surface: 'mud' },
    ],
    features: [
      { kind: 'roots', s: 300, length: 30, height: 0.08 },
      { kind: 'log', s: 450, length: 0.8, height: 0.25 },
      { kind: 'log', s: 1100, length: 0.8, height: 0.25 },
      { kind: 'ford', s: 1300, length: 12, depth: 0.5 },
      { kind: 'roots', s: 1500, length: 30, height: 0.08 },
      { kind: 'log', s: 1700, length: 0.8, height: 0.25 },
      { kind: 'log', s: 2000, length: 0.8, height: 0.25 },
      { kind: 'log', s: 2550, length: 0.8, height: 0.25 },
      { kind: 'roots', s: 2700, length: 30, height: 0.08 },
    ],
  },
  forest: { corridor: 7, spacing: 4, density: 0.55, minRadius: 0.2, maxRadius: 0.35 },
  starts: { default: { s: 5 } },
  checkpoints: [0, 300, 600, 900, 1200, 1500, 1800, 2100, 2400, 2700],
  props: [],
};
